<template lang="pug">
.report-card.mr-XS.mb-XS.p-XS
  .main-icon.p-XXS.mx-0.my-XS
    BriqIcon(:name="icon" :customStyle="`width: 100%; height: 100%`")
  .title.type-bold {{ title }}
  .description.type-small.mb-S {{ description }}
  .float-bottom
    BriqButton.download-button(@click="openReportDrawer" variant="secondary" submit)
      BriqIcon(name="icon-input-plus-icon" :customStyle="plusIconCustomStyling")
      span.ml-XXS Create export
  ReportDrawer(
    ref="ReportDrawer" 
    :title="title" 
    :name="name" 
    :description="description" 
    :endpoint="endpoint" 
    :localTimezone="localTimezone" 
    :separatorValues="separatorValues"
    :defaultSeparatorValue="defaultSeparatorValue"
    :filterBy="filterBy"
    :customDateRangeLimit="customDateRangeLimit"
    :dateRangeDisabledDates="dateRangeDisabledDates"
    :maxDate="maxDate"
    :exportNotification="exportNotification"
    :periodIsRequired="periodIsRequired"
  )
</template>

<script>
import ReportDrawer from './ReportDrawer.vue'

export default {
  name: 'ReportCard',
  components: { ReportDrawer },
  props: {
    title: String,
    name: String,
    description: String,
    endpoint: String,
    icon: String,
    periodIsRequired: Boolean,
    localTimezone: String,
    separatorValues: Array,
    defaultSeparatorValue: String,
    filterBy: Object,
    maxDate: String,
    exportNotification: String,
    customDateRangeLimit: {
      default: null,
      type: Number,
    },
    dateRangeDisabledDates: {
      default: null,
      type: Array
    }
  },
  data() {
    return {
      period: null,
      plusIconCustomStyling: 'margin-top: -3px; width: 0.75em; height: 0.75em;',
    }
  },

  methods: {
    openReportDrawer() {
      this.$refs.ReportDrawer.openReportDrawer()
    }
  }
}
</script>

<style scoped lang="stylus">
.report-card
  min-height 280px
  width 224px
  background white
  border 1px solid rgb(225, 225, 225)
  display flex
  flex-direction column
  align-items center

  .main-icon
    width 154px
    height 64px

  .title
    text-align center
    margin-bottom 12px

  .description
    color #96999D
    text-align center

  .float-bottom
    margin-top auto

  .icon-input-plus-icon
    margin-right 12px
    font-size 10px
</style>
